<template>
	<div class="store-list-item" :class="[isCourse(item.type)?'course':'fiction']" @click="handleToDetail(item.shop_source_id)">
		<div class="box-img">
			<div class="img" :style="{'background-image': 'url('+item.our_image+')'}" v-if="item.our_image"></div>
			<div class="img" :style="{'background-image': 'url('+item.image+')'}" v-else></div>

			<span class="bt-tag" v-if="item.is_subsidize === '1'"><i></i></span>
		</div>
		<div class="inner">
			<div class="title">
				<span class="tag">{{item.type_name}}</span>{{item.title}}
			</div>
			<div class="info" v-if="isCourse(item.type)">
				<div class="price">￥<strong class="number"> <nr-amount :value="item.price" /></strong></div>
				<!-- <div class="sales" v-if="item.platform_sell_count!='0'">{{item.platform_sell_count | tranNumber}}人已学习</div> -->
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		props: {
			item: {
				type: Object,
				default: ()=>{
					return {}
				}
			}
		},
		methods: {
			//去详情
			handleToDetail(id) {
				this.$router.push({
					name: 'storeDetail',
					params: {
						id: id,
						shopId: this.$route.params.shopId
					},
					query: {
						store: this.$store.getters.getStoreInfo.name || '我的小店'
					}
				})
			}
		},
	}
</script>

<style lang="scss">
	.store-list-item{
		margin: 0;
		break-inside: avoid;
		border-radius: 20px;
		overflow: hidden;
		background-color: #fff;
		position: relative;
		
		.box-img{
			width: 100%;
			height: 0;
			position: relative;
		}
		.bt-tag{
      position: absolute;
      top: 0;
      left: 8px;
      padding: 0 10px;
      height: 36px;
      border-radius:  0 0 8px 8px;
      background: linear-gradient(128deg, #D9B468 0%, #EFDAB0 100%);
      z-index: 2;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      i{
        width: 48px;
        height: 20px;
        background: url('../../home/imgs/bt.svg') no-repeat;
        background-size: contain;
      }
    }
		.img{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #e8e8e8;
			overflow: hidden;
			border-top-right-radius: 20px;
			border-top-left-radius: 20px;
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
		}
		.inner{
			padding: 26px 16px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
		.title{
			position: relative;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			font-size: 28px;
			line-height: 1.4;
			color: #333333;
			max-height: 72px;
			font-weight: bold;
			/* autoprefixer: ignore next */
			-webkit-box-orient: vertical;
		}
		.tag{
			font-size: 20px;
			width: 60px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			color: #fff;
			border-radius: 1px;
			padding: 0 10px;
			margin-right: 10px;
			position: relative;
			top: -1px;
			border-radius: 4px;
		}
		.info{
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			font-size: 24px;
			margin-top: 30px;

			.price{
				color: #FE0D0D;
			}
			.number{
				font-size: 32px;
			}
			.sales{
				color: #CCCCCC;
				margin-left: 20px;
				overflow: hidden;
			    text-overflow: ellipsis;
			    white-space: nowrap
			}
		}
		&.course{
			
			.inner{
				// height: 200px;
			}
			.box-img{
				padding-bottom: calc(100% / 1.75);
			}
			.tag{
				background:linear-gradient(53deg,rgba(62,160,249,1) 0%,rgba(87,204,253,1) 100%);
			}
		}
		&.fiction{
			
			.inner{
				// height: 62px;
			}
			.box-img{
				padding-bottom: calc(100% * 1.4);
			}
			.tag{
				background:linear-gradient(53deg,rgba(242,142,157,1) 0%,rgba(248,174,179,1) 100%);
			}
			.info{
				display: none;
			}
		}
	}
</style>